import { render, staticRenderFns } from "./UserMultimedia.vue?vue&type=template&id=39d95a04&"
import script from "./UserMultimedia.vue?vue&type=script&lang=js&"
export * from "./UserMultimedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports